<ng-container [ngSwitch]="platformType">
  <ng-container *ngSwitchCase="HTVPlatform.TIZEN">
    <object class="player" type="application/avplayer" aria-label="avplayer"></object>
  </ng-container>
  <ng-container *ngSwitchCase="HTVPlatform.WEBOS">
    <div class="player" style="background-image: url('TV:')"></div>
  </ng-container>
  <ng-container *ngSwitchDefault>
    <div class="player"></div>
  </ng-container>
</ng-container>
